import moment from "moment-timezone";
import { rrulestr } from "rrule";
import { DsaScheduleDto, DsaScheduleEventDto } from "../generated/dashboard-client";
import { nowInEventFrame } from "./dsaEventTime";

function isRecurring(event: DsaScheduleEventDto): boolean {
  return !!event.repeat && event.repeat !== "no-repeat" && !!event.rrule;
}

function isEventActiveNow(event: DsaScheduleEventDto, nowMs: number, screenTimezone?: string): boolean {
  if (event.removed) return false;
  if (event.startDate == null || event.endDate == null) return false;

  // a timezone-agnostic event plays on the screen's clock, so compare against the wall clock the
  // screen is showing rather than against the raw instant
  const now = nowInEventFrame(event, nowMs, screenTimezone);

  if (!isRecurring(event)) {
    return now >= event.startDate && now <= event.endDate;
  }

  const durationMs = event.endDate - event.startDate;
  if (durationMs < 0) return false;

  const ruleSet = rrulestr(
    `DTSTART:${moment.utc(event.startDate).format("YYYYMMDDTHHmmss")}\nRRULE:${event.rrule}`,
    { forceset: true }
  );
  const occurrenceStart = ruleSet.before(new Date(now), true);
  if (!occurrenceStart) return false;

  const elapsed = now - occurrenceStart.getTime();
  return elapsed >= 0 && elapsed <= durationMs;
}

export function findActiveScheduleEvent(
  schedule: DsaScheduleDto,
  nowMs: number,
  screenTimezone?: string
): DsaScheduleEventDto | undefined {
  return (schedule.events ?? [])
    .filter(event => isEventActiveNow(event, nowMs, screenTimezone))
    .sort((a, b) => (a.startDate ?? 0) - (b.startDate ?? 0))[0];
}
